import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getUserRoundMultiplierList } from "store/actions";
import Table from "components/Table";
import Columns from "./Columns";
import FormikForm from "components/shared/FormikForm";
import UserRoundMultiplierModal from "components/Modals/userRoundMultiplier/userRoundMultiplierModal";

const InputFieldsForSearch = [
  {
    name: "search",
    type: "text",
    label: "",
    placeholder: "Search...",
  },
  {
    name: "disabledType",
    label: "",
    type: "select",
    placeholder: "Select Disabled Type",
    options: [
      { value: "", label: "All" },
      { value: "auto", label: "Auto" },
      { value: "manual", label: "Manual" },
    ],
  },
];

const initialValuesForFilter = {
  search: "",
  disabledType: "",
};

const List = ({ userDetails }) => {
  const dispatch = useDispatch();

  const { userRoundMultiplierList, loading, userRoundMultiplierTotalCount } =
    useSelector(({ RoundMultiplier }) => ({
      loading: RoundMultiplier?.loading,
      userRoundMultiplierList: RoundMultiplier?.userRoundMultiplierList,
      userRoundMultiplierTotalCount:
        RoundMultiplier?.userRoundMultiplierTotalCount,
    }));

  const [userRoundMultiplierModalShow, setUserRoundMultiplierModalShow] =
    useState(false);
  const [id, setId] = useState(null);

  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    order: -1,
    orderBy: "date_created_utc",
    search: "",
    userId: "",
    disabledType: "",
  });

  // ✅ View Handler
  const handleViewHandler = (info) => {
    let id = info?._id;

    if (typeof id === "object" && id !== null) {
      id = id?.$oid || id?.toString();
    }

    if (!id || typeof id !== "string") {
      console.error("Invalid ID:", id);
      return;
    }

    setId(id);
    setUserRoundMultiplierModalShow(true);
  };

  // ✅ Columns (memoized)
  const columns = useMemo(() => {
    return Columns({ handleViewHandler });
  }, []);

  // ✅ Set userId
  useEffect(() => {
    if (!userDetails?._id) return;

    setFilter((prev) => ({
      ...prev,
      userId: userDetails._id,
    }));
  }, [userDetails]);

  // ✅ API Call
  useEffect(() => {
    if (!filter.userId) return;

    dispatch(getUserRoundMultiplierList({ data: filter }));
  }, [filter, dispatch]);

  // ✅ Filter Submit
  const handleFilterForm = (info) => {
    setFilter((prev) => ({
      ...prev,
      search: info.search,
      disabledType: info.disabledType,
      page: 1,
    }));
  };

  return (
    <div className="section-body">
      {/* Filter */}
      <div className="card">
        <div className="row justify-content-between">
          <div className="col-12">
            <div className="card-header">
              <FormikForm
                initialValues={initialValuesForFilter}
                onSubmit={handleFilterForm}
                loading={loading}
                inputFields={InputFieldsForSearch}
                buttonText={"Search"}
              />
            </div>
          </div>
        </div>
      </div>

      {/* ✅ FIXED Modal condition */}
      {userRoundMultiplierModalShow && (
        <UserRoundMultiplierModal
          show={userRoundMultiplierModalShow}
          handleClose={() => {
            setUserRoundMultiplierModalShow(false);
            setId(null);
          }}
          title={"Round Multiplier Details"}
          id={id}
        />
      )}

      {/* Table */}
      {!loading && userRoundMultiplierList?.length > 0 && (
        <Table
          data={userRoundMultiplierList}
          columns={columns}
          setFilter={setFilter}
          total={userRoundMultiplierTotalCount}
          filter={filter}
        />
      )}

      {/* Empty */}
      {!loading && userRoundMultiplierList?.length === 0 && (
        <p style={{ textAlign: "center" }}>No Data Found</p>
      )}
    </div>
  );
};

export default List;
